import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'buttonWrapper', 'enterButton', 'exitButton'];

  connect() {
    this.isMaximized = this.containerTarget.classList.contains('fullscreen');
    this.handleKeydown = this.handleKeydown.bind(this);
    document.addEventListener('keydown', this.handleKeydown);
    this.applyState();
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.documentElement.classList.remove('fullscreen-active');
    document.body.classList.remove('fullscreen-active');
  }

  toggle() {
    this.isMaximized = !this.isMaximized;
    this.applyState();
  }

  handleKeydown(event) {
    if (event.key !== 'Escape' || !this.isMaximized) return;
    if (document.querySelector('dialog[open]:modal')) return; // Escape belongs to the topmost dialog
    this.isMaximized = false;
    this.applyState();
  }

  applyState() {
    this.containerTarget.classList.toggle('fullscreen', this.isMaximized);
    document.documentElement.classList.toggle('fullscreen-active', this.isMaximized);
    document.body.classList.toggle('fullscreen-active', this.isMaximized);

    if (this.hasEnterButtonTarget)
      this.enterButtonTarget.classList.toggle('active', !this.isMaximized);
    if (this.hasExitButtonTarget)
      this.exitButtonTarget.classList.toggle('active', this.isMaximized);
  }
}
